module.exports = __webpack_public_path__ + "static/media/error-bold.1c9181fb.svg";